/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_DataInputs */

const en_entity_data = /** @type {(inputs: Entity_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

const de_entity_data = /** @type {(inputs: Entity_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten`)
};

/**
* | output |
* | --- |
* | "Data" |
*
* @param {Entity_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_data = /** @type {((inputs?: Entity_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_data(inputs)
	return de_entity_data(inputs)
});